import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  GET_USER_PROFILE,
  SET_AUTH,
  SET_EDITOR_AUTH,
} from "actions/ActionTypes";
import history from "components/common/navigation/AppHistory";
import { fetchApi } from "actions/FetchActions";
import { customize } from "utils/hoc/Customize";

import auth from "utils/Auth";
import { loaderStatus } from "utils/Utilities";

import CustomButton from "components/customComponents/CustomButton";
import CustomText from "components/customComponents/CustomText";

import { OAUTH_ROUTE, PROJECTS_ROUTE } from "../routes/routes";

import "css/storefront/oauth.scss";

class OauthSuccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain: null,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const params = JSON.parse(
      window.atob(decodeURIComponent(match.params.session)),
    );
    const { oauth_provider, storefront_domain, avatar_url, token } = params;
    auth.setSession("true", token, avatar_url);
    if (params.token) {
      this.props.setSession(token);
    }
    if (oauth_provider === "admin_impersonate") {
      localStorage.editor_authorised = !!token;
      history.push(params.redirect_to || PROJECTS_ROUTE);
    } else if (oauth_provider === "edu_liblynx") {
      if (
        !storefront_domain ||
        storefront_domain.includes(window.location.host)
      ) {
        history.push(PROJECTS_ROUTE);
      } else {
        loaderStatus.next(false);
        this.openTab(storefront_domain);
      }
    } else {
      window.opener.postMessage(
        {
          status: "okast-oauth-success",
          session: {
            avatar_url,
            token,
          },
        },
        "*",
      );
      window.opener.focus();
      window.close();
    }
    this.setState({
      domain: storefront_domain,
    });
  }

  openTab = (url) => {
    const { match } = this.props;

    const tab = window.open(
      `${url}${OAUTH_ROUTE}/success/${match.params.session}`,
      "_blank",
    );
    tab ? tab.focus : null;
  };

  render() {
    const { domain } = this.state;
    const { t, getStyles } = this.props;
    const iconStyles = getStyles("oauth:icon");
    const containerStyles = getStyles("oauth:success_container");

    return (
      <div className="oauth-success-container">
        {!domain && <div>AUTH SUCCESS!</div>}

        {domain && (
          <div className="oauth-success-wrapper" style={containerStyles}>
            <CustomText namespace="contents">
              <i className="material-icons check" style={iconStyles}>
                check_circle_outline
              </i>
            </CustomText>
            <CustomText
              isRouterLink={false}
              namespace="contents"
              isTitle={false}
            >
              <span>{t("oauthRedirectText")}</span>
            </CustomText>
            <CustomText
              isRouterLink={false}
              namespace="contents"
              className="redirect-subtext"
              isTitle={false}
            >
              <span>{t("oauthRedirectSubtext")}</span>
            </CustomText>
            <CustomText namespace="contents">
              <i className="material-icons arrow-down" style={iconStyles}>
                arrow_downward
              </i>
            </CustomText>
            <CustomButton
              isRouterLink={false}
              namespace="contents"
              onClick={() => this.openTab(domain)}
              className="content-btn cursor-pointer"
            >
              {t("oauthRedirectBtn")}
            </CustomButton>
          </div>
        )}
      </div>
    );
  }
}

OauthSuccess.propTypes = {
  getStyles: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  setSession: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setSession(token) {
    dispatch({ type: SET_AUTH, loggedIn: true });
    dispatch({ type: SET_EDITOR_AUTH, editorAuth: true });
    dispatch(
      fetchApi({
        endpoint: "/api/user/v2/session",
        type: GET_USER_PROFILE,
        token,
      }),
    );
  },
});

export default customize("contents")(
  connect(null, mapDispatchToProps)(withTranslation("login")(OauthSuccess)),
);
